<template>
  <header class="site-page-header">
    <div class="site-page-header__layout">
      <div class="site-page-header__content">
        <div class="site-section-title" v-if="eyebrow">{{ eyebrow }}</div>
        <h1 class="site-page-title">{{ title }}</h1>
        <p class="site-page-summary" v-if="summary">{{ summary }}</p>
      </div>
      <div class="site-page-header__media" v-if="$slots.media">
        <slot name="media"/>
      </div>
      <div class="site-actions site-page-header__actions" v-if="$slots.actions">
        <slot name="actions"/>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import {Component, Prop} from 'vue-property-decorator'
import {PortalVueBase} from '@/view/PortalVueBase'

@Component
export default class SitePageHeader extends PortalVueBase {
  @Prop({required: true}) title!: string
  @Prop({default: ''}) summary!: string
  @Prop({default: ''}) eyebrow!: string
}
</script>
